<template>
  <div class="hello">
    <div class="custom-text" style="display: flex;justify-content: center;margin-top: 36px; font-size: 18px">
      <div style="width: 360px; ;text-align: left;">
        1、中央台、地方台、网络台应有尽有；<br>
        2、支持CarPlay车载功能；<br>
        3、支持回听、收藏、定时关闭；<br>
        4、支持暗黑模式、字体大小设置；<br>
        5、支持添加自定义电台等功能；<br>
        安卓端正在陆续同步苹果端功能，敬请期待。
      </div>
    </div>

    <div class="swiper-container">
      <img class="img-limit" src="@/assets/image_page1.png" alt="Image 1" />
      <img class="img-limit" src="@/assets/image_page2.png" alt="Image 1" />
      <img class="img-limit" src="@/assets/image_page3.png" alt="Image 1" />
      <img class="img-limit" src="@/assets/image_page4.png" alt="Image 1" />
    </div>

    <div
      class="custom-text"
      style="margin-top: 40px; font-weight: 800; font-size: 24px"
    >
      App点击下载
    </div>
    <div style="height: 24px"></div>
    <div class="flex-center">
      <div class="down-seaction-size custom-text" @click="openAppDownAction(1)">
        苹果 AppStore
      </div>
      <div style="width: 24px"></div>
      <div class="down-seaction-size custom-text" @click="openAppDownAction(2)">
        安卓下载
      </div>
    </div>
    <div style="height: 120px;"></div>
  </div>
</template>

<script>
export default {
  name: "InvitePage",
  components: {},
  props: {
    msg: String,
  },
  setup() {
    return {
      items: [
        "@/assets/image_page1.png",
        "@/assets/image_page2.png",
        "@/assets/image_page3.png",
        "@/assets/image_page4.png",
      ],
    };
  },
  methods:{
    openAppDownAction(index){
      if (index == 1){
        window.open('https://apps.apple.com/cn/app/%E5%B0%8F%E6%97%8B%E9%A3%8E%E6%94%B6%E9%9F%B3%E6%9C%BA-fm%E8%B0%83%E9%A2%91%E5%B9%BF%E6%92%AD%E7%94%B5%E5%8F%B0/id6458733365', '_blank');
      }else{
        window.open('https://www.pgyer.com/xiaoxuanfengfm', '_blank');
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiper-container {
  margin-top: 24px;
  width: 100%;
  background-color: #f0f0f0;
  display: flex;
  overflow: scroll;
  /* justify-content: center; */
  /* flex-wrap: wrap; */
}
.img-limit {
  padding: 5px;
  width: 200px;
  height: 100%;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.down-seaction-size {
  color: white;
  width: 120px;
  height: 80px;
  line-height: 80px;
  background-color: #111111;
  border-radius: 8px;
}
</style>
